import Alpine from "alpinejs"
import collapse from "@alpinejs/collapse";
import Marquee from "vanilla-marquee"
import SplitType from "split-type"
import { gsap } from "gsap"
import { ExpoScaleEase } from "gsap/EasePack"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import Swiper, {
  Navigation,
  Pagination,
  Keyboard,
  Thumbs,
  EffectFade,
  Mousewheel,
  FreeMode,
  Autoplay,
  EffectCoverflow,
} from "swiper"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/effect-fade"
import "swiper/css/effect-coverflow"
import Lenis from "@studio-freight/lenis"
import { TRUE } from "sass";

// import "./animations"
const lenis = new Lenis()

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)



Swiper.use([
  Autoplay,
  Pagination,
  Navigation,
  Thumbs,
  EffectFade,
  Keyboard,
  Mousewheel,
  EffectCoverflow,
  FreeMode,
])
window.Swiper = Swiper
window.SplitType = SplitType
Alpine.plugin(collapse);
window.Alpine = Alpine

Alpine.start()
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ExpoScaleEase,);
gsap.config({ nullTargetWarn: false });
const isMobile = window.innerWidth <= 1024;
const chisiamoMob = window.innerWidth < 767;
const chisiamoTablet = window.innerWidth < 1024;

// funzione video intro e animazioni home
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.close-intro').forEach(function (element) {
    element.addEventListener('click', myHandler, false);
  });

  // document.getElementById('introVideo').addEventListener('ended', myHandler, false);
  var introVideoElement = document.getElementById('introVideo');

  if (introVideoElement) {
    introVideoElement.addEventListener('ended', myHandler, false);
  }
  function myHandler() {
    document.querySelector('.custom-intro-video').style.display = 'none';
    introVideo.muted = true;
    document.body.style.overflowY = 'visible';
    const myText = new SplitType('.title-animate-home')
    gsap.to('.word', {
      y: 0,
      stagger: 0.05,
      delay: 0.3,
      opacity: 1,
      duration: .1
    })
    if(window.innerWidth >= 1024){
      let ctahomecustom = gsap.timeline();
      ctahomecustom.from(".animate-cta-home", {
        duration: 1.75,
        delay: 1,
        x: 300,
        autoAlpha: 0,
        ease: "elastic.out(1, 1)",
        stagger: {
          each: 0.75,
          amount: 0.5
        }
      }, "+=0.25");
    }
  }
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.close-intro').forEach(function (element) {
    element.addEventListener('click', myHandler, false);
  });

  // document.getElementById('introVideoMobile').addEventListener('ended', myHandler, false);
  var introVideoElementMob = document.getElementById('introVideo');

  if (introVideoElementMob) {
    introVideoElementMob.addEventListener('ended', myHandler, false);
  }

  function myHandler() {
    document.querySelector('.custom-intro-video').style.display = 'none';
    introVideoMobile.muted = true;
    document.body.style.overflowY = 'visible';
    const myText = new SplitType('.title-animate-home')
    gsap.to('.word', {
      y: 0,
      stagger: 0.05,
      opacity: 1,
      delay: 0.3,
      duration: .1
    })
    if(window.innerWidth < 1024){
      let ctahomecustom = gsap.timeline();
      ctahomecustom.from(".animate-cta-home", {
        duration: 1.75,
        delay: 1,
        x: 300,
        autoAlpha: 0,
        ease: "elastic.out(1, 1)",
        stagger: {
          each: 0.75,
          amount: 0.5
        }
      }, "+=0.25");
    }
  }
});
// CURSORE
// gsap.set(".flair", {xPercent: -50, yPercent: -50});

// let xSetter = gsap.quickSetter(".flair", "x", "px") //apply it to the #id element's x property and append a "px" unit
// let ySetter = gsap.quickSetter(".flair", "y", "px") //apply it to the #id element's x property and append a "px" unit

// window.addEventListener("mousemove", e => {  
//   xSetter(e.x)
//   ySetter(e.y)
// });
gsap.set(".flair", { xPercent: -50, yPercent: -50,});

let xSetter = gsap.quickSetter(".flair", "x", "px");
let ySetter = gsap.quickSetter(".flair", "y", "px");
let bounceStrength = 0.2;
let mouseX = 0;
let mouseY = 0;
window.addEventListener("mousemove", e => {
  mouseX = e.x;
  mouseY = e.y;
});
function animate() {
  let deltaX = mouseX - gsap.getProperty(".flair", "x");
  let deltaY = mouseY - gsap.getProperty(".flair", "y");
  xSetter(gsap.getProperty(".flair", "x") + deltaX * bounceStrength);
  ySetter(gsap.getProperty(".flair", "y") + deltaY * bounceStrength);
  requestAnimationFrame(animate);
}
animate();

//header
console.log("Prima del listener: ", window.scrollY)
var lastPosition = window.scrollY
let navbar = document.getElementById("header");
let navbarFixed = document.getElementById("header-white");
var logo = navbar.querySelector("img");

var containerLogo = logo.parentElement
if (window.innerWidth <= 1200) {
  containerLogo.style = "overflow: hidden; display: flex; justify-content: flex-end; height: 4.25rem;";
} else {
  // Altrimenti (desktop), imposta l'altezza a 5.625rem
  containerLogo.style = "overflow: hidden; display: flex; justify-content: flex-end; height: 5.625rem;";
}

// containerLogo.style = "overflow:hidden; display: flex; justify-content: flex-end; height: 5.625rem;"
logo.style = "height: 100%; width: auto; max-width: none"

var navContent = navbar.querySelector(".container");

// var tll = gsap.timeline({
//   paused: true
// })

// tll.to(containerLogo, {
//   width: `${containerLogo.offsetWidth*0.6}px`,
//   // clipPath: "inset(0 0 0 0)"
//   // clipPath: "inset(0 0 0 41%)",
//   duration: 0.3,
//   ease: "power1",
//   // paused: true,
//   // onComplete: () => {
//   // 	navContent.classList.remove("py-8")
//   // },
// })

// tll.to(navContent, {
//   paddingBlock: 0,
//   // paddingTop: 0,
//   // paddingBottom: 0,
//   duration: 0.15,
//   delay: 0.2
// })
// gsap.set(navbar, { backgroundColor: 'rgba(255, 255, 255, 0)' });

// Animazione per rendere il background bianco
// tll.to(navbar, {
//   // backgroundColor: 'rgba(255, 255, 255, 1)', // Opacità completa (1) per il bianco
//   paddingBlock: 0,
//   duration: 0.15,
//   delay: 0.2
// });

// var animation = gsap.to(navbar, {
//   y: `-${navbar.offsetHeight}px`,
//   paused: true,
//   duration: 0.3,
//   ease: "power1",
// })
var animationScrollDown = gsap.fromTo(navbarFixed, {y: `0`,}, {
  y: `-${navbarFixed.offsetHeight}px`,
  paused: true,
  duration: 0.3,
  ease: "power1",
})
animationScrollDown.play()

// window.addEventListener("scroll", () => {
//   let scroll = window.scrollY

//   if (scroll > 60) {

//     tll.play()

//     // navContent.classList.remove("py-8")

//     if (scroll - lastPosition > 0) {
//       // navbar.style.display = "none"
//       document.getElementById("header").classList.add("headerScrolled");
//       animation.play()
//       lastPosition = scroll
//     } else if (scroll - lastPosition < 0) {
//       // navbar.style.display = "block"
//       animation.reverse()
//       lastPosition = scroll
//     }
//   } else {
//     document.getElementById("header").classList.remove("headerScrolled");
//     // navContent.classList.add("py-8")
//     tll.reverse()
//   }
// })
window.addEventListener("scroll", () => {
  let scroll = window.scrollY

  if (scroll > window.innerHeight) {

    if (scroll - lastPosition > 0) {

      animationScrollDown.play()
      lastPosition = scroll

    } else if (scroll - lastPosition < 0) {
      animationScrollDown.reverse()
      lastPosition = scroll
    }
  } else {
    animationScrollDown.play()
  }
})


//parallax k home
// gsap.to(".parallax-bg-img", {
//   backgroundPosition: `10% 250%`, // All'inizio l'immagine è allineata in basso
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".parallax-bg-img",
//     scrub: true,
//     start: "top bottom", // Inizia quando il top del trigger raggiunge il bottom della finestra di visualizzazione
//     end: "bottom top" // Finisce quando il bottom del trigger raggiunge il top della finestra di visualizzazione
//   }
// });

// gsap.to(".parallax-bg-home", {
//   backgroundPosition: `10% 100%`, // All'inizio il contenitore è allineato in basso
//   ease: "none",
//   scrollTrigger: {
//     trigger: ".parallax-bg-home",
//     scrub: true,
//     start: "top bottom",
//     end: "bottom top"
//   }
// });

const Dskbreakpoint = window.innerWidth > 1024;
gsap.to(".parallax-bg-img", {
  backgroundPosition: `50% ${-innerHeight / (Dskbreakpoint ? 0.9 : 1.3)}px`,
  ease: "none",
  scrollTrigger: {
    trigger: ".parallax-bg-img",
    scrub: true,
  }, 
});

gsap.to(".parallax-bg-home", {
  backgroundPosition: `50% ${-innerHeight / 3}px`,
  ease: "none",
  scrollTrigger: {
    trigger: ".parallax-bg-home",
    scrub: true
  }, 
});

//img progetti
const imgProgetti = document.querySelectorAll(".img-animate-progetti")
imgProgetti.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.7, scale: 0.9 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    scale: 1,
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom 80%",
      toggleActions: "play none none reverse",
    },
  })
})
// text progetti
const textProgetti1 = document.querySelectorAll(".text-animate-progetti-1")
textProgetti1.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.5 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.5,
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
    },
  })
})
const textProgetti2 = document.querySelectorAll(".text-animate-progetti-2")
textProgetti2.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.7 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
    },
  })
})

//video home
const origScale = 0.7
const dur = 0.7
const origBorderRadius = 30
const finalBorderRadius = 1

gsap.set(".video", {
  scale: origScale,
  borderRadius: `${origBorderRadius}rem`,
})

ScrollTrigger.defaults({
  toggleActions: "restart pause resume pause",
  markers: false,
})

const work = document.querySelectorAll(".ACF-work")

work.forEach((item, index) => {
  const video = item.querySelector(".video")
  const setScaleX = gsap.quickSetter(video, "scaleX")
  const setScaleY = gsap.quickSetter(video, "scaleY")
  const setBorderRadius = gsap.quickSetter(video, "borderRadius")
  let isClicked = false

  const proxy = {
    scale: origScale,
    borderRadius: origBorderRadius,
  }
  
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: item,
      scrub: dur,
      start: isMobile ? "top bottom-=10%" : "top bottom-=80%",
      end: "50% center",
    },
    onUpdate: () => {
      if (!isClicked) {
        setScaleX(proxy.scale)
        setScaleY(proxy.scale)
        setBorderRadius(`${proxy.borderRadius}rem`)
      }
    },
  })
  

  tl.to(proxy, {
    scale: 1.4,
    borderRadius: finalBorderRadius,
  })

  const tlReverse = gsap.timeline({
    scrollTrigger: {
      trigger: item,
      scrub: dur,
      start: "25% top",
      end: "bottom top",
    },
    onUpdate: () => {
      if (!isClicked) {
        setScaleX(proxy.scale)
        setScaleY(proxy.scale)
        setBorderRadius(`${proxy.borderRadius}rem`)
      }
    },
  })

  tlReverse.to(proxy, {
    scale: origScale,
    borderRadius: origBorderRadius,
  })

  tl.add(tlReverse)

  item.addEventListener("click", () => {
    isClicked = !isClicked

    if (isClicked) {
      gsap.to(video, {
        scale: origScale,
        borderRadius: `${origBorderRadius}rem`,
        duration: dur,
        overwrite: "auto",
      })
    } else {
      tl.reverse() // Inverte entrambe le timeline quando viene fatto clic
    }
  })
})
//hero home
gsap.utils.toArray('.video-parallax-home').forEach((section, i) => {
  ScrollTrigger.create({
    trigger: section,
    start: "top",
    end: "bottom",
    pin: true,
    pinSpacing: false
  });
});

// titolo home
const myText = new SplitType(".title-animate")
gsap.to(".char", {
  y: 0,
  stagger: 0.05,
  delay: 0.3,
  duration: 0.1,
})

// titolo xl
// const titleXl = new SplitType(".title-animate-xl")
// gsap.to(".char", {
//   y: 0,
//   stagger: 0.05,
//   delay: 0.3,
//   duration: 0.1,
// })
// titolo l
// const titleL = new SplitType(".title-animate-l")
// gsap.to(".char", {
//   y: 0,
//   stagger: 0.05,
//   delay: 0.3,
//   duration: 0.1,
// })
// prova anim word
const titleXl = new SplitType(".title-animate-xl")
gsap.to(".word", {
  y: 0,
  stagger: 0.1,
  delay: 0.3,
  duration: 0.1,
  opacity: 1,
})
const titleL = new SplitType(".title-animate-l")
gsap.to(".word", {
  y: 0,
  stagger: 0.1,
  delay: 0.3,
  duration: 0.2,
  opacity: 1,
})

// testo
const textAnimate = document.querySelectorAll(".text-animate")
textAnimate.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.7 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    delay: isMobile ? 0.5 : 1,
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
      markers: false,
    },
  });
});
// testo home chi-siamo
const textAnimateChisiamo = document.querySelectorAll(".text-animate-chisiamo")
textAnimateChisiamo.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.7 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    delay: 0,
    scrollTrigger: {
      trigger: element,
      start: isMobile ? "top 90%" : "top bottom",
      end: "bottom top",
      toggleActions: "play none none reverse",
      markers: false,
    },
  });
});

// Fade-in
const blockFade = document.querySelectorAll(".fade-in-custom")
blockFade.forEach((element) => {
  gsap.set(element, { opacity: 0, y: 100, duration: 0.7 })

  gsap.to(element, {
    opacity: 1,
    y: 0,
    duration: 0.7,
    delay: 0,
    scrollTrigger: {
      trigger: element,
      start: "top 99%",
      end: "bottom 99%",
      toggleActions: "play none none reverse",
    },
  });
});
// cta
let ctahome = gsap.timeline();
ctahome.from(".animate-cta", {
  duration: 1.75,
  delay: 1,
  x: 300,
  autoAlpha: 0,
  ease: "elastic.out(1, 1)",
  stagger: {
    each: 0.75,
    amount: 0.5
  }
}, "+=0.25");


gsap.set(".animate-cta-home-reverse", { autoAlpha: 1 });
let ctahomereverse = gsap.timeline();
ctahomereverse.from(".animate-cta-home-reverse", {
  duration: 2,
  delay: 1.2,
  x: -300,
  autoAlpha: 1,
  ease: "elastic.out(1, 1)",
  stagger: {
    each: 0.75,
    amount: 0.5
  }
}, "+=0.25");
//cosa facciamo
document.addEventListener("DOMContentLoaded", () => {
  const marqueeElements = document.querySelectorAll(".marquee-dsk")
  marqueeElements.forEach((element) => {
    new Marquee(element, {
      duplicated: true,
      gap: isMobile ? 20 : 50,
      speed: isMobile ? 20 : 100,
      startVisible: true,
    })
  })
})
// Home clienti
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 1024) {
    const marqueeElements = document.querySelectorAll(".marquee-clienti")
    marqueeElements.forEach((element) => {
      new Marquee(element, {
        duplicated: true,
        gap: 88,
        speed: 40,
        startVisible: true,
        pauseOnHover: true,
      })
    })

    const marqueeElementsSotto = document.querySelectorAll(".marquee-clienti-sotto")
    marqueeElementsSotto.forEach((element) => {
      new Marquee(element, {
        duplicated: true,
        gap: 88,
        speed: 40,
        startVisible: true,
        direction: "ltr",
        pauseOnHover: true,
      })
    })
  }
})
document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 1023) {
    const marqueeElements = document.querySelectorAll(".marquee-clienti")
    marqueeElements.forEach((element) => {
      new Marquee(element, {
        duplicated: true,
        gap: chisiamoMob ? 16 : 40,
        speed: 20,
        startVisible: true,
        pauseOnHover: true,
      })
    })

    const marqueeElementsSotto = document.querySelectorAll(".marquee-clienti-sotto")
    marqueeElementsSotto.forEach((element) => {
      new Marquee(element, {
        duplicated: true,
        gap: chisiamoMob ? 16 : 40,
        speed: 20,
        startVisible: true,
        direction: "ltr",
        pauseOnHover: true,
      })
    })
  }
})
// ancor link funzione per scroll lento
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault()

    document.querySelector(this.getAttribute("href")).scrollIntoView({
      behavior: "smooth",
    })
  })
})

// animazione frecce svg
const animatedBoxes = document.querySelectorAll(".svg-animate-container")

animatedBoxes.forEach((box) => {
  const svgAnimate = box.querySelector(".svg-animate")
  const tl = gsap.timeline({ paused: true })

  tl.to(svgAnimate, { x: "130%", opacity: 1, duration: 0.2 })
    .to(svgAnimate, { x: "-130%", opacity: 0, duration: 0 })
    .to(svgAnimate, { x: 0, opacity: 1, duration: 0.2 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})
// animazione contattaci footer
const animatedContattaci = document.querySelectorAll(".text-animate-contattaci")

animatedContattaci.forEach((box) => {
  const textAnimate = box.querySelector(".text-contattaci")
  const tl = gsap.timeline({ paused: true })

  tl.to(textAnimate, { y: "-200%", opacity: 1, duration: 0.2 })
    .to(textAnimate, { y: "200%", opacity: 0, duration: 0 })
    .to(textAnimate, { y: 0, opacity: 1, duration: 0.2 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})
// NUOVA ANIM CTA
const animatedCta = document.querySelectorAll(".text-animate-cta")

animatedCta.forEach((box) => {
  const textAnimatecta = box.querySelector(".text-cta")
  const tl = gsap.timeline({ paused: true })

  tl.to(textAnimatecta, { y: "-80%", opacity: 1, duration: 0.15 })
    .to(textAnimatecta, { y: "50%", opacity: 1, duration: 0 })
    .to(textAnimatecta, { y: 0, opacity: 1, duration: 0.15 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})

// animazione link footer
const animatedLinksFooter = document.querySelectorAll(
  ".text-animate-links-footer"
)

animatedLinksFooter.forEach((box) => {
  const linksAnimateFooter = box.querySelector(".text-links-footer")
  const tl = gsap.timeline({ paused: true })

  tl.to(linksAnimateFooter, { y: "-80%", opacity: 1, duration: 0.15 })
    .to(linksAnimateFooter, { y: "80%", opacity: 0, duration: 0 })
    .to(linksAnimateFooter, { y: 0, opacity: 1, duration: 0.15 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})
// animazione link header
const animatedLinks = document.querySelectorAll(".text-animate-links")

animatedLinks.forEach((box) => {
  const linksAnimate = box.querySelector(".text-links")
  const tl = gsap.timeline({ paused: true })

  tl.to(linksAnimate, { y: "-120%", opacity: 1, duration: 0.2 })
    .to(linksAnimate, { y: "120%", opacity: 0, duration: 0 })
    .to(linksAnimate, { y: 0, opacity: 1, duration: 0.2 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})

// animazione navbar cosa facciamo
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)

ScrollTrigger.config({
  autoRefreshEvents: "visibilitychange,DOMContentLoaded,load, resize",
})
const links = gsap.utils.toArray(".nav-animate")
const sections = gsap.utils.toArray(".section")

links.forEach((btn, index) => {
  btn.addEventListener("click", () => {
    gsap.to("body", {
      duration: 1,
      scrollTo: { y: sections[index], autoKill: true, ease: "power2" },
    })

    for (let i = 0; i < 4; i++) {
      prev = links
      if (prev[i].classList.contains("active-nav")) {
        prev[i].classList.remove("active-nav")
      }
    }
    btn.classList.add("active-nav")
  })
})
sections.forEach((section, i) => {
  ScrollTrigger.create({
    trigger: section,
    scroller: "body",
    start: "top bottom",
    end: "bottom 100%",
    markers: false,
    onToggle: (self) => {
      if (self.isActive) {
        gsap.to(links[i], {
          backgroundColor: "#fff",
          outlineColor: "#fff",
          color: "#021015",
          ease: "power2",
        })
      } else {
        gsap.to(links[i], {
          backgroundColor: "transparent",
          color: "#fff",
          outlineColor: "rgba(255,255,255,0.3)",
          ease: "power2",
        })
      }
    },
  })
})

// BLOCCO CHI SIAMO NUMBERS E STRATEGIE

document.addEventListener('DOMContentLoaded', function() {
  const provaElement = document.getElementById('box-k-numbers');
  if (provaElement) {
    const provaHeight = provaElement.offsetHeight;
    const valore2 = 100;
    const valore3 = provaHeight - 600;
    const x = (valore2 * valore3) / provaHeight;

    gsap.to('#box-k-numbers', {
      yPercent: -x,
      ease: "none",
      scrollTrigger: {
        trigger: "#pin",
        pin: "#pin",
        start: "top top",
        end: "bottom top",
        pinSpacing: true,
        scrub: true,
        markers: false,
        onLeave: () => {
          // La funzione di callback onUpdate viene chiamata ogni volta che lo scroll trigger viene aggiornato
          if(!chisiamoTablet){
            updateOtherScrollTriggers();
          }
        },
      }
    });
  }

  gsap.utils.toArray(".chi-siamo-marquee").forEach((section) => {
    gsap.to(section.children[0], {
      x: "-100%",
    });
  });

  gsap.to("#chi-siamo-strategie", {
    scrollTrigger: {
      trigger: "#chi-siamo-strategie",
      markers: false,
      start: "top top",
      end: "bottom bottom",
      pin: "#chi-siamo-strategie-title-wrapper",
      pinSpacing: false,
    },
  });

  gsap.to("#chi-siamo-strategie-title", {
    scrollTrigger: {
      trigger: "#chi-siamo-strategie",
      markers: false,
      start:  chisiamoTablet ? "top center" : "top top",
      end: "top+=20% top",
      scrub: 1,
      toggleActions: "play none none reverse",
    },
    scale: chisiamoTablet ? 1 : 0.5,
    duration: 0.8,
    y: chisiamoMob ? -(window.innerHeight - 69) : (chisiamoTablet ?  -(window.innerHeight - 69) : -150),
    transformOrigin: "top left",
    ease: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  gsap.to("#chi-siamo-strategie-text", {
    scrollTrigger: {
      trigger: "#chi-siamo-strategie",
      markers: false,
      start: chisiamoTablet ? "top center" : "top top",
      end: "top+=20% top",
      scrub: 1,
      toggleActions: "play none none reverse",

    },
    opacity: chisiamoTablet ?  1 : 0,
    scale: chisiamoTablet ?  1 : 0.5,
    duration: 0.8,
    y: chisiamoMob ? -(window.innerHeight - 69) : (chisiamoTablet ? -(window.innerHeight - 69) : -150),
    transformOrigin: "top left",
    ease: "cubic-bezier(0.22, 1, 0.36, 1)",
    
  });

  // opacity text tablet e mobile
  if(chisiamoTablet){
  gsap.to("#chi-siamo-strategie-text", {
    scrollTrigger: {
      trigger: "#chi-siamo-strategie",
      markers: false,
      start: chisiamoTablet ? "top+=20% center" : "top top",
      end: "top+=20% top",
      scrub: 1,
      toggleActions: "play none play reverse",

    },
    opacity: chisiamoTablet ?  0 : 0,
    duration: 0.8,
    transformOrigin: "top left",
    ease: "cubic-bezier(0.22, 1, 0.36, 1)",
    
  });
  }



  gsap.utils.toArray(".chi-siamo-strategia").forEach((section, i, array) => {
    const isLast = i === array.length - 1;
    const l = i + 1;
    gsap.fromTo(
      section,
      {
        opacity: 0.3,
        scale: 0.8,
        transformOrigin: "top left",
      },
      {
        scrollTrigger: {
          trigger: section,
          start: chisiamoMob ? "top top+=65%" : (chisiamoTablet ? "top top+=70%" : "top center"),
          end: chisiamoMob ? "bottom top+=65%" : (chisiamoTablet ? "bottom top+=70%" : "bottom center"),
          // start: chisiamoTablet ? "top top+=65%": "top center",
          // end: chisiamoTablet ? "bottom top+=65%" : "bottom center",
          toggleActions: "play reverse play reverse",
          markers: false,
          onEnter: () => {
            section.classList.remove("!opacity-0", "transition-opacity", "duration-300");
          },
          
          onLeave: () => {
            if (!isLast) {
              section.classList.add("!opacity-0", "transition-opacity", "duration-300");
            }
            else{
              section.classList.add("transition-opacity", "duration-300");
            }
          },
          onEnterBack: () => {
            section.classList.remove("!opacity-0", "transition-opacity", "duration-300");
          },
        },
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: "cubic-bezier(0.22, 1, 0.36, 1)",
        transformOrigin: "top left",
      }
    );
  });

  var containerStrategie = document.querySelector("#container-strategie");

  const videoWrapper = document.querySelector("#chi-siamo-strategie-video-wrapper");
  // const videos = videoWrapper.querySelectorAll(".video");
  // const reverse = videoWrapper.querySelectorAll(".reverse");
  // const all = videoWrapper.querySelectorAll("video");

  gsap.to(videoWrapper, {
    scrollTrigger: {
      trigger: "#video-section",
      markers: false,
      start: "top top",
      end: "bottom bottom",
      pin: videoWrapper,
      pinSpacing: false,
    },
  });

  // videos[0].onloadedmetadata = function () {
  //   tl.to(videos[0], { currentTime: videos[0].duration });
  // };

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: containerStrategie,
      start: "top bottom",
      end: "bottom top",
      scrub: 0.5,
    }
  });
});
// DSK STRATEGIE
function updateOtherScrollTriggers() {
  // console.log("updateOtherScrollTriggers chiamata con successo!");
  ScrollTrigger.refresh();
  // console.log("refresh!");
  gsap.utils.toArray(".section-parallax .parallax-content").forEach((section) => {
    gsap.fromTo(
      section,
      {
        y: 0,
      },
      {
        scrollTrigger: {
          trigger: section,
          start: "top center",
          scrub: 0.01,
        },

        ease: "none",
      }
    );
  });


  const frameCount = 267;
  const path = window.location.origin;
  const folderPath = `${path}/wp-content/themes/keywe2/dist/img/chi-siamo/frames-strategie/`;
  // const folderPath = 'http://keywe.local/wp-content/themes/keywe2/dist/img/chi-siamo/frames-strategie/';

// Creazione dell'array di URL
  const urls = new Array(frameCount).fill().map((_, i) => {
    const frameNumber = (i + 1).toString().padStart(3, '0'); // Formatta il numero del frame con zeri iniziali
    return `${folderPath}Composizione%209${frameNumber}.jpg`; // Costruisci l'URL del frame
  });


  // console.log(urls);
  imageSequence({
    urls, // Array of image URLs
    canvas: "#image-sequence", // <canvas> object to draw images to
    //clear: true, // only necessary if your images contain transparency
    //onUpdate: (index, image) => console.log("drew image index", index, ", image:", image),
    scrollTrigger: {
      trigger: "#video-section",
      start: "top top",
      end: "bottom bottom",
      scrub: true, // important!
      markers: false,
    }
  });
  function drawImageScaled(img, ctx) {
    var canvas = ctx.canvas;
    var hRatio = canvas.width  / img.width;
    var vRatio =  canvas.height / img.height;
    var ratio  = Math.min(hRatio, vRatio);
    var centerShift_x = (canvas.width - img.width * ratio) / 2;
    var centerShift_y = (canvas.height - img.height * ratio) / 2;  
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);  
  }

  function imageSequence(config) {
    let playhead = { frame: 0 };
    let canvas = gsap.utils.toArray(config.canvas)[0] || console.warn("canvas not defined");
    let ctx = canvas.getContext("2d");
    let curFrame = -1;
    let onUpdate = config.onUpdate;
    let images;

    let updateImage = function() {
      let frame = Math.round(playhead.frame);
      if (frame !== curFrame) {
        drawImageScaled(images[Math.round(playhead.frame)], ctx);
        curFrame = frame;
        onUpdate && onUpdate.call(this, frame, images[frame]);
      }
    };

    images = config.urls.map((url, i) => {
      let img = new Image();
      img.src = url;
      i || (img.onload = updateImage);
      return img;
    });

    return gsap.to(playhead, {
      frame: images.length - 1,
      ease: "none",
      onUpdate: updateImage,
      duration: images.length / (config.fps || 30),
      paused: !!config.paused,
      scrollTrigger: config.scrollTrigger
    });
  }
}


// MOBILE STRATEGIE
const thereiscanva = document.getElementById('image-sequence-mob')
document.addEventListener('DOMContentLoaded', function() {
if(chisiamoTablet && thereiscanva){
  function updateOtherScrollTriggers() {
    // console.log("updateOtherScrollTriggers chiamata con successo!");
    ScrollTrigger.refresh();
    // console.log("refresh!");
    gsap.utils.toArray(".section-parallax .parallax-content").forEach((section) => {
      gsap.fromTo(
        section,
        {
          y: 0,
        },
        {
          scrollTrigger: {
            trigger: section,
            start: "top center",
            scrub: 0.01,
          },
  
          ease: "none",
        }
      );
    });
  
  
    const frameCount = 267;
    const path = window.location.origin;
    const folderPath = `${path}/wp-content/themes/keywe2/dist/img/chi-siamo/frames-strategie/`;
    // const folderPath = 'http://keywe.local/wp-content/themes/keywe2/dist/img/chi-siamo/frames-strategie/';
  
    // Creazione dell'array di URL
    const urls = new Array(frameCount).fill().map((_, i) => {
      const frameNumber = (i + 1).toString().padStart(3, '0'); // Formatta il numero del frame con zeri iniziali
      return `${folderPath}Composizione%209${frameNumber}.jpg`; // Costruisci l'URL del frame
    });
  
  
    // console.log(urls);
    imageSequence({
      urls, // Array of image URLs
      canvas: "#image-sequence-mob", // <canvas> object to draw images to
      scrollTrigger: {
        trigger: "#video-section",
        start: "top top",
        end: "bottom bottom",
        scrub: true, // important!
        markers: false,
      }
    });
    function drawImageScaled(img, ctx) {
      var canvas = ctx.canvas;
      var hRatio = canvas.width  / img.width;
      var vRatio =  canvas.height / img.height;
      var ratio  = Math.min(hRatio, vRatio);
      var centerShift_x = (canvas.width - img.width * ratio) / 2;
      var centerShift_y = (canvas.height - img.height * ratio) / 2;  
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, img.width, img.height, centerShift_x, centerShift_y, img.width * ratio, img.height * ratio);  
    }
  
    function imageSequence(config) {
      let playhead = { frame: 0 };
      let canvas = gsap.utils.toArray(config.canvas)[0] || console.warn("canvas not defined");
      let ctx = canvas.getContext("2d");
      let curFrame = -1;
      let onUpdate = config.onUpdate;
      let images;
  
      let updateImage = function() {
        let frame = Math.round(playhead.frame);
        if (frame !== curFrame) {
          drawImageScaled(images[Math.round(playhead.frame)], ctx);
          curFrame = frame;
          onUpdate && onUpdate.call(this, frame, images[frame]);
        }
      };
  
      images = config.urls.map((url, i) => {
        let img = new Image();
        img.src = url;
        i || (img.onload = updateImage);
        return img;
      });
  
      return gsap.to(playhead, {
        frame: images.length - 1,
        ease: "none",
        onUpdate: updateImage,
        duration: images.length / (config.fps || 30),
        paused: !!config.paused,
        scrollTrigger: config.scrollTrigger
      });
    }
  }
  updateOtherScrollTriggers();
}
});


// WPML
const animatedWpmls = document.querySelectorAll(".wpml-ls-link")

animatedWpmls.forEach((box) => {
  const svgAnimate = box.querySelector(".wpml-ls-native")
  const tl = gsap.timeline({ paused: true })

  tl.to(svgAnimate, { x: "130%", opacity: 1, duration: 0.2 })
    .to(svgAnimate, { x: "-130%", opacity: 0, duration: 0 })
    .to(svgAnimate, { x: 0, opacity: 1, duration: 0.2 })

  box.addEventListener("mouseenter", () => tl.play())
  box.addEventListener("mouseleave", () => tl.reverse())
})


